import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Popover
} from 'reactstrap';  
import Select from 'react-select';
import { reduxForm } from 'redux-form';
import { SketchPicker } from 'react-color';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { addRequerimento, updateRequerimento } from "../../Services/RequerimentoService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      active: false,
      displayColorPicker: false,

      fases: [],
      selectedFase: '',
      selectOptionsF: [],

      events: [],
      selectedEvent: '',
      selectOptionsEvent: [],

      substancias: [],
      selectedSub: '',
      selectOptionsSub: [],
      
      selectedUso: '',
      selectOptionsUso: [],

      estados: [],
      checkboxEstados: [],
      checkboxEstadosSelected: [],
      requerimentoCidade: [],
      checkboxCidades: [],
      checkboxCidadesSelected: [],

      data: {
        id: '',
				name: '',
				ano: '',
				areaHA: '',
				fase: '',
				idCode: '',
				numero: '',
				processo: '',
				substancia: '',
				evento: '',
        substanciaUso: '',
        uf: '',
				color: '#87CEFA',
        colorRGB: {r: 135, g: 206, b: 250, a: 1},
				status: "ATIVO",
				deleted: false,
				createdAt: '',
        updatedAt: '',
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }


    console.log(data);

    if(this.validateEntries()){

      let rgb = JSON.stringify(data['colorRGB']);
      data['colorRGB'] = rgb;

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }

      let request = {
        requerimento: data,
        requerimentoEstadoList: this.getRequerimentoEstado(),
        requerimentoCidadeList: this.getRequerimentoCidade()
      };
  
      if(data.id === undefined || data.id === null || data.id === ''){
        // addRequerimento(request)
        // .then(obj => {
        //   if(obj !== null && obj !== undefined && obj.error === undefined){
        //     if(obj.erros.length === 0){
        //       this.props.updateTable({}, this.props.t('forms.dataCreateSuccess'));
        //       this.clear();              
        //     }else{
        //       if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
        //         for(let i = 0; i < obj.erros.length; i++){
        //           this.show('danger', this.props.t('erros.'+obj.erros[i]));
        //         }
        //       }
        //     }
        //   } else {
        //     this.show('danger', this.props.t('forms.dataCreateError'));
        //   }
        // });

      }else{
        updateRequerimento(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.processo === undefined || data.processo === null || data.processo === ''){
      this.show('danger', this.props.t('forms.requiredFieldProccess'));
      validated = false;
    }
    
    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }

    if(data.numero === undefined || data.numero === null || data.numero === ''){
      this.show('danger', this.props.t('forms.requiredFieldNumber'));
      validated = false;
    }

    if(data.ano === undefined || data.ano === null || data.ano === ''){
      this.show('danger', this.props.t('forms.requiredFieldYear'));
      validated = false;
    }

    if(data.idCode === undefined || data.idCode === null || data.idCode === ''){
      this.show('danger', this.props.t('forms.requiredFieldCode'));
      validated = false;
    }

    if(data.areaHA === undefined || data.areaHA === null || data.areaHA === ''){
      this.show('danger', this.props.t('forms.requiredFieldAreaHE'));
      validated = false;
    }

    if(data.fase === undefined || data.fase === null  || 
      data.fase.id === undefined || data.fase.id === null || data.fase.id === 0){
      this.show('danger', this.props.t('forms.requiredFieldPhase'));
      validated = false;
    }

    if(data.evento === undefined || data.evento === null || 
      data.evento.id === undefined || data.evento.id === null || data.evento.id === 0){
      this.show('danger', this.props.t('forms.requiredFieldEvent'));
      validated = false;
    }

    if(data.substancia === undefined || data.substancia === null || 
      data.substancia.id === undefined || data.substancia.id === null || data.substancia.id === 0){
      this.show('danger', this.props.t('forms.requiredFieldSubs'));
      validated = false;
    }

    if(data.substanciaUso === undefined || data.substanciaUso === null || 
      data.substanciaUso.id === undefined || data.substanciaUso.id === null || data.substanciaUso.id === 0){
      this.show('danger', this.props.t('forms.requiredFieldSubsUso'));
      validated = false;
    }

    if(data.uf === undefined || data.uf === null || data.uf === ''){
      this.show('danger', this.props.t('forms.requiredFieldUF'));
      validated = false;
    }

    return validated;  
  }

  getRequerimentoEstado() {
    let requerimentoEstado = [];
    if(this.state.checkboxEstadosSelected.length > 0){
      for(let j = 0; j < this.state.checkboxEstadosSelected.length; j++){
        for(let i = 0; i < this.state.estados.length; i++){
          if(this.state.checkboxEstadosSelected[j].value === this.state.estados[i].id){
            requerimentoEstado.push( {estado: this.state.estados[i]} );
            break;
          }
        }
      }
    }
    return requerimentoEstado;
  }

  getRequerimentoCidade() {
    let requerimentoCidade = [];
    let cidades = [];
    let cidadeEncontrada = false;
    if(this.state.checkboxCidadesSelected.length > 0){
      for(let j = 0; j < this.state.checkboxCidadesSelected.length; j++){
        cidadeEncontrada = false;
        for(let e = 0; e < this.state.estados.length; e++){
          cidades = this.state.estados[e].cidades;
          for(let i = 0; i < cidades.length; i++){
            if(this.state.checkboxCidadesSelected[j].value === cidades[i].id){
              requerimentoCidade.push( {cidade: cidades[i]} );
              cidadeEncontrada = true;
              break;
            }
          }
          if(cidadeEncontrada){
            break;
          }
        }
      }
    }
    return requerimentoCidade;
  }

  loadData(selected, fases, events, substancias, estados, requerimentoEstado, requerimentoCidade) {
    let options = [];
    let optionsC = [];
    let optionsUso = [];
    let optionsSelected = [];
    let optionsSelectedC = [];
    let cidades = [];
    let requerimentoCidadeList = [];
    let obj = {};
    let objC = {};

    if(fases !== undefined && fases !== null && fases.length > 0 && this.state.fases.length === 0){
      for(let i = 0; i < fases.length; i++){
        options.push({value:fases[i].id, label: fases[i].name});
      }
      this.setState({ 
        selectOptionsF: options, 
        fases: fases 
      });
    }

    options = [];
    if(events !== undefined && events !== null && events.length > 0 && this.state.events.length === 0){
      for(let i = 0; i < events.length; i++){
        options.push({value:events[i].id, label: events[i].name});
      }
      this.setState({ 
        selectOptionsEvent: options, 
        events: events 
      });
    }

    options = [];
    if(substancias !== undefined && substancias !== null && substancias.length > 0 && this.state.substancias.length === 0){
      for(let i = 0; i < substancias.length; i++){
        options.push({value:substancias[i].id, label: substancias[i].name});
      }
      this.setState({ 
        selectOptionsSub: options, 
        substancias: substancias 
      });
    }

    options = [];
    if(requerimentoCidade !== undefined && requerimentoCidade !== null && requerimentoCidade.length > 0 ){
      requerimentoCidadeList = requerimentoCidade;
    }
    if(estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length === 0){
      if(requerimentoEstado !== undefined && requerimentoEstado !== null && requerimentoEstado.length > 0){
        for(let i = 0; i < estados.length; i++){
          obj = {value:estados[i].id, label: estados[i].name, uf: estados[i].uf, checked: false, checkedAll: false};
          for(let j = 0; j < requerimentoEstado.length; j++){
            if(estados[i].id === requerimentoEstado[j].estado.id){
              obj.checked = true;
              optionsSelected.push(obj);
              cidades = estados[i].cidades;

              for(let i2 = 0; i2 < cidades.length; i2++){
                objC = {value:cidades[i2].id, label: estados[i].uf + " - " + cidades[i2].name, uf: estados[i].uf, checked: false};
                for(let j2 = 0; j2 < requerimentoCidadeList.length; j2++){
                  if(cidades[i2].id === requerimentoCidadeList[j2].cidade.id){
                    objC.checked = true;
                    optionsSelectedC.push(objC);
                    break;
                  }
                }
                optionsC.push(objC);
              }
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < estados.length; i++){
          options.push({value:estados[i].id, label: estados[i].name, uf: estados[i].uf, checked: false, checkedAll: false});
        }
      }
      
      this.setState({ 
        checkboxEstados: options,
        checkboxEstadosSelected: optionsSelected,
        estados: estados,
        checkboxCidades: optionsC, 
        checkboxCidadesSelected: optionsSelectedC,
        requerimentoCidade: requerimentoCidade,
      })
    }

    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {
        
        let selectedFase = '';
        if(selected.fase !== undefined && selected.fase !== null && selected.fase.id !== null){
          selectedFase = {value:selected.fase.id, label: selected.fase.name};
        }
        
        let selectedEvent = '';
        if(selected.evento !== undefined && selected.evento !== null && selected.evento.id !== null){
          selectedEvent = {value:selected.evento.id, label: selected.evento.name};
        }
        
        let selectedSub = '';
        let selectOptionsUso = [];
        if(selected.substancia !== undefined && selected.substancia !== null && selected.substancia.id !== null){
          selectedSub = {value:selected.substancia.id, label: selected.substancia.name};

          for(let i = 0; i < substancias.length; i++){
            if(substancias[i].id === selected.substancia.id){
              for(let j = 0; j < substancias[i].substanciasUso.length; j++){
                selectOptionsUso.push({value:substancias[i].substanciasUso[j].id, label: substancias[i].substanciasUso[j].name});
              }
            }
          }
        }

        let selectedUso = '';
        if(selected.substanciaUso !== undefined && selected.substanciaUso !== null && selected.substanciaUso.id !== null){
          selectedUso = {value:selected.substanciaUso.id, label: selected.substanciaUso.name};
        }        

        this.setState({ 
          data: selected, selectedFase, selectedEvent, selectedSub, selectOptionsUso, selectedUso
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected, fases, events, substancias, estados, requerimentoEstado, requerimentoCidade } = this.props;
    this.loadData(selected, fases, events, substancias, estados, requerimentoEstado, requerimentoCidade);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected || props.fases !== this.props.fases || 
        props.events !== this.props.events || props.substancias !== this.props.substancias || 
        props.estados !== this.props.estados || props.requerimentoEstado !== this.props.requerimentoEstado || 
        props.requerimentoCidade !== this.props.requerimentoCidade){
      this.loadData(this.props.selected, this.props.fases, this.props.events, this.props.substancias, this.props.estados, this.props.requerimentoEstado, this.props.requerimentoCidade);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data });
  }

  updateCheckboxEstado(event) {
    let selecteds = [];
    let objC = {};
    let cidades = [];
    let optionsC = [];
    let optionsSelectedC = [];

    event.checked = !event.checked;
    if(this.state.checkboxEstadosSelected.length > 0){
      for(let i = 0; i < this.state.checkboxEstadosSelected.length; i++){
        if(this.state.checkboxEstadosSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxEstadosSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }

    for(let i = 0; i < selecteds.length; i++){
      for(let j = 0; j < this.state.estados.length; j++){
        if(selecteds[i].value === this.state.estados[j].id){
          cidades = this.state.estados[j].cidades;

          for(let i2 = 0; i2 < cidades.length; i2++){
            objC = {value:cidades[i2].id, label: this.state.estados[j].uf + " - " + cidades[i2].name, uf: this.state.estados[j].uf, checked: false};
            for(let j2 = 0; j2 < this.state.checkboxCidadesSelected.length; j2++){
              if(cidades[i2].id === this.state.checkboxCidadesSelected[j2].value){
                objC.checked = true;
                optionsSelectedC.push(objC);
                break;
              }
            }
            optionsC.push(objC);
          }
        }
      }
    }

    this.setState({ 
      checkboxEstadosSelected: selecteds.sort((a, b) => (a.label > b.label) ? 1 : -1),
      checkboxCidades: optionsC.sort((a, b) => (a.label > b.label) ? 1 : -1), 
      checkboxCidadesSelected: optionsSelectedC.sort((a, b) => (a.label > b.label) ? 1 : -1) 
    });
  }
  

  updateCheckboxCidadeAll(event){
    let selecteds = [];
    let item = {};
    event.checkedAll = !event.checkedAll;
    if(this.state.checkboxCidades.length > 0){
      for(let i = 0; i < this.state.checkboxCidades.length; i++){
        item = this.state.checkboxCidades[i];
        if(item.uf === event.uf){
          item.checked = event.checkedAll;
        }
        if(item.checked){
          selecteds.push(item);
        }
      }
    }
    this.setState({ 
      checkboxCidadesSelected: selecteds.sort((a, b) => (a.label > b.label) ? 1 : -1) 
    });
  }


  updateCheckboxCidade(event) {
    let selecteds = [];
    event.checked = !event.checked;
    if(this.state.checkboxCidadesSelected.length > 0){
      for(let i = 0; i < this.state.checkboxCidadesSelected.length; i++){
        if(this.state.checkboxCidadesSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxCidadesSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ 
      checkboxCidadesSelected: selecteds.sort((a, b) => (a.label > b.label) ? 1 : -1)  
    });
  }

  updateFaseSelect(event) {
    const data = { ...this.state.data }

    let selectedFase = '';
    data["fase"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < this.state.selectOptionsF.length; i++){
          if(this.state.selectOptionsF[i].value === event[j].value){
            selectedFase = event[j];
            
            for(let e = 0; e < this.state.fases.length; e++){
              if(this.state.fases[e].id === selectedFase.value){
                data["fase"] = this.state.fases[e];
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ data, selectedFase });
  }

  updateEventSelect(event) {
    const data = { ...this.state.data }

    let selectedEvent = '';
    data["evento"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < this.state.selectOptionsEvent.length; i++){
          if(this.state.selectOptionsEvent[i].value === event[j].value){
            selectedEvent = event[j];
            
            for(let e = 0; e < this.state.events.length; e++){
              if(this.state.events[e].id === selectedEvent.value){
                data["evento"] = this.state.events[e];
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ data, selectedEvent });
  }

  updateFaseSub(event) {
    const data = { ...this.state.data }

    let selectedSub = '';
    let selectOptionsUso = [];
    let selectedUso = '';
    data["substancia"] = '';
    data["substanciaUso"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        selectOptionsUso = [];
        for(let i = 0; i < this.state.selectOptionsSub.length; i++){
          if(this.state.selectOptionsSub[i].value === event[j].value){
            selectedSub = event[j];
            
            for(let e = 0; e < this.state.substancias.length; e++){
              if(this.state.substancias[e].id === selectedSub.value){
                data["substancia"] = this.state.substancias[e];

                for(let s = 0; s < this.state.substancias[e].substanciasUso.length; s++){
                  selectOptionsUso.push({value:this.state.substancias[e].substanciasUso[s].id, label: this.state.substancias[e].substanciasUso[s].name});
                }
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ data, selectedSub, selectOptionsUso, selectedUso });
  }

  updateFaseUso(event) {
    const data = { ...this.state.data }

    let selectedUso = '';
    data["substanciaUso"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < this.state.selectOptionsUso.length; i++){
          if(this.state.selectOptionsUso[i].value === event[j].value){
            selectedUso = event[j];
            
            for(let e = 0; e < this.state.substancias.length; e++){
              if(this.state.substancias[e].id === this.state.data.substancia.id){
                for(let s = 0; s < this.state.substancias[e].substanciasUso.length; s++){
                  if(this.state.substancias[e].substanciasUso[s].id === selectedUso.value){
                    data["substanciaUso"] = this.state.substancias[e].substanciasUso[s];
                  }
                }
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ data, selectedUso });
  }


  clear(){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['ano'] = '';
    data['areaHA'] = '';
    data['fase'] = '';
    data['idCode'] = '';
    data['numero'] = '';
    data['processo'] = '';
    data['substancia'] = '';
    data['evento'] = '';
    data['substanciaUso'] = '';
    data['uf'] = '';
    data['color'] = '#87CEFA';
    data['colorRGB'] = {r: 135, g: 206, b: 250, a: 1};
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';

    this.setState({ 
      data,
      checkboxEstadosSelected: [],
      checkboxCidadesSelected: [],
      checkboxCidades: [],
      active: false,
      displayColorPicker: false
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  handleClick = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ displayColorPicker: !prevState.displayColorPicker, active: !prevState.active }));
  };

  handleChange = (color) => {
    const data = { ...this.state.data }
    data['color'] = color.hex;
    data['colorRGB'] = color.rgb;
    this.setState({ data });
  };

  render() {
    const { t } = this.props;
    const { data, active, displayColorPicker } = this.state;
    const color = data.color;
    const rgb = data.colorRGB;
    
    let notOK = !hasAccess("MENU_REQUIREMENT_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let checkboxesEstadosAll = [];
    let checkboxesEstados = [];
    let checkboxesCidades = [];
    let checked = false;

    let total = this.state.checkboxEstados.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checked = false;
        if(this.state.checkboxEstadosSelected.includes(this.state.checkboxEstados[i])){
          checked = true;
          checkboxesEstadosAll.push(
            <div key={"divestadosAll_"+this.state.checkboxEstados[i].value} className='form__form-inline' style={{width: '60px'}}>
              <input type="checkbox" 
                id={"checkboxestadosAll_"+this.state.checkboxEstados[i].value} 
                name={"checkboxestadosAll_"+this.state.checkboxEstados[i].value} 
                style={{float: 'left', width: '30px', height: '18px'}}
                onChange={e => this.updateCheckboxCidadeAll(this.state.checkboxEstados[i])}
                checked={this.state.checkboxEstados[i].checkedAll} 
              />
                <label 
                  key={"labelestadosAll_"+this.state.checkboxEstados[i].value}
                  htmlFor={"checkboxestadosAll_"+this.state.checkboxEstados[i].value} 
                  style={{margin: 0, height: '25px'}}>
                  {this.state.checkboxEstados[i].uf}
                </label>
            </div>
          );
        }
        checkboxesEstados.push(
          <div key={"divestados_"+this.state.checkboxEstados[i].value} className='form__form-inline' style={{width: '170px'}}>
            <input type="checkbox" 
              id={"checkboxestados_"+this.state.checkboxEstados[i].value} 
              name={"checkboxestados_"+this.state.checkboxEstados[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxEstado(this.state.checkboxEstados[i])}
              checked={checked} 
            />
              <label 
                key={"labelestados_"+this.state.checkboxEstados[i].value}
                htmlFor={"checkboxestados_"+this.state.checkboxEstados[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxEstados[i].label}
              </label>
          </div>
        );
      }
    }

    total = this.state.checkboxCidades.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checkboxesCidades.push(
          <div key={"divcidades_"+this.state.checkboxCidades[i].value} className='form__form-inline' style={{width: '205px'}}>
            <input type="checkbox" 
              id={"checkboxcidades_"+this.state.checkboxCidades[i].value} 
              name={"checkboxcidades_"+this.state.checkboxCidades[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxCidade(this.state.checkboxCidades[i])}
              checked={this.state.checkboxCidadesSelected.includes(this.state.checkboxCidades[i])} 
            />
              <label 
                key={"labelcidades_"+this.state.checkboxCidades[i].value}
                htmlFor={"checkboxcidades_"+this.state.checkboxCidades[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxCidades[i].label}
              </label>
          </div>
        );
      }
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.processo')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="hidden" 
                      name="id"
                      value={this.state.data.id} />
                    <input type="text" 
                      name="processo"
                      value={this.state.data.processo}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.numero')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="numero"
                      value={this.state.data.numero}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.code')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="idCode"
                      value={this.state.data.idCode}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.fase')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <Select
                      isMulti = "true"
                      maxMenuHeight="150px"
                      name="fase"
                      value={this.state.selectedFase}
                      onChange={e => this.updateFaseSelect(e)}
                      options={this.state.selectOptionsF}
                      clearable={true}
                      className="react-select"
                      classNamePrefix="react-select"
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.substancia')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <Select
                        isMulti = "true"
                        maxMenuHeight="150px"
                        name="substancia"
                        value={this.state.selectedSub}
                        onChange={e => this.updateFaseSub(e)}
                        options={this.state.selectOptionsSub}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                        required
                      />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.uf')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="uf"
                      value={this.state.data.uf}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
              </div>


              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="name"
                      value={this.state.data.name}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.ano')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="ano"
                      value={this.state.data.ano}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.areaHA')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="areaHA"
                      value={this.state.data.areaHA}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.evento')}
                  </span>
                  <div className="form__form-group-field">
                    <Select
                        isMulti = "true"
                        maxMenuHeight="150px"
                        name="evento"
                        value={this.state.selectedEvent}
                        onChange={e => this.updateEventSelect(e)}
                        options={this.state.selectOptionsEvent}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                        required
                      />
                  </div>
                </div>

                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.substanciaUso')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <Select
                        isMulti = "true"
                        maxMenuHeight="150px"
                        name="substanciaUso"
                        value={this.state.selectedUso}
                        onChange={e => this.updateFaseUso(e)}
                        options={this.state.selectOptionsUso}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                        required
                      />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.color')} 
                  </span>
                  <div className="form__form-group-field">
                    <div className="color-picker">
                      <button
                        type="button"
                        className={`color-picker__button${active ? ' active' : ''}`}
                        onClick={this.handleClick}
                        id="color"
                      >
                        <p className="color-picker__color">{color}</p>
                        <div className="color-picker__color-view" style={{ backgroundColor: color }} />
                      </button>
                      <Popover
                        isOpen={displayColorPicker}
                        target="color"
                        placement="bottom"
                        className="color-picker__popover"
                      >
                        <SketchPicker
                          color={rgb}
                          onChange={e => this.handleChange(e)}
                        />
                      </Popover>
                    </div>                    
                  </div>
                </div>
              </div>


              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.estado_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesEstados}

                </div>
              </div>
              <div className="form__form-group">
                <div style={{float: 'left', marginRight: '5px'}}>
                  <span className="form__form-group-label">
                    {t('forms.cidade_form.title')} 
                  </span>
                </div>
                <div style={{float: 'left'}}>
                {checkboxesEstadosAll}
                </div>
                <div className="form__form-group-field" 
                  style={{clear: 'both', border: '1px solid #CCCCCC', height: '400px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesCidades}

                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'requerimentoEdit', 
})(withTranslation('common')(CrudEdit));
